const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/profile_fields/$id/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { validateProfileFieldPrefillSearchParams } from "@circle-react/components/SettingsApp/ProfileFields/helpers";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/profile_fields/$id/edit")({
  validateSearch: validateProfileFieldPrefillSearchParams,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});